export default {
  zh: {
    index: '首页',
    download: '下载',
    faq: '常见问题',
    signOut: '退 出',
    settings: '设置',
    invitationRecords: '邀请记录',
    topUpRecords: '充值记录',
    affiliate: '联盟推广',
    backend: '管理后台',
    device_manage: '设备管理'
  },
  en: {
    index: 'Home',
    download: 'Download',
    faq: 'FAQ',
    signOut: 'Sign Out',
    settings: 'Settings',
    invitationRecords: 'Invitation Records',
    topUpRecords: 'Purchase Records',
    affiliate: 'Affiliate',
    backend: 'Backend',
    device_manage: 'Device Management'
  }
}



// WEBPACK FOOTER //
// ./src/components/plexHeader/userCenterHeader/lang.js